import {
  // -- GET (array of objects)
  LIST_SIMULATION_SUCCESS,
  LIST_SIMULATION_FAILURE,

  // -- DELETE
  DELETE_SIMULATION_SUCCESS,
  DELETE_SIMULATION_FAILURE,

  // -- SEARCH
  SEARCH_SIMULATIONS
} from '../../actions'

import { Logger, LoggerTypes } from '../../utils'

let cacheItems = null

export const simulations = (state = {}, action) => {
  switch (action.type) {
    // -- SEARCH SIMULATIONS
    case SEARCH_SIMULATIONS: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }
      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      // Logger.trace(LoggerTypes.REDUCER, '[REDUCER] simulations.SEARCH_SIMULATIONS()', { state, cacheItems, txt: action.data, searchItems })
      return {
        ...state,
        items: searchItems
      }
    }

    // -- GET SIMULATIONS (list)
    case LIST_SIMULATION_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] simulations.LIST_SIMULATION_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case LIST_SIMULATION_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] simulations.LIST_SIMULATION_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data || null
      }
    }

    // -- DELETE SIMULATION
    case DELETE_SIMULATION_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] simulations.DELETE_SIMULATION_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case DELETE_SIMULATION_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data.id)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] simulations.DELETE_SIMULATION_SUCCESS()', { state, action, items })

      return {
        ...state,
        items
      }
    }

    default:
      return state
  }
}
